import { ActivatedRouteSnapshot, BaseRouteReuseStrategy } from '@angular/router';

/**
 * Forces Angular to recreate the views when switching projects. By default
 * Angular reuses the component because the route config is the same and only the
 * `:projectId` param changes, so `ngOnInit` never runs again and the view keeps
 * showing the previous project's data.
 *
 * The `projectId` is not always in the active route's `params` (child routes do
 * not inherit it), so it is looked up across the whole chain from the root.
 */
export class ProjectRouteReuseStrategy extends BaseRouteReuseStrategy {
  override shouldReuseRoute(future: ActivatedRouteSnapshot, current: ActivatedRouteSnapshot): boolean {
    if (future.routeConfig !== current.routeConfig) {
      return false;
    }

    const futureProjectId = this.getProjectId(future);
    const currentProjectId = this.getProjectId(current);
    if (futureProjectId && currentProjectId && futureProjectId !== currentProjectId) {
      return false;
    }

    return true;
  }

  private getProjectId(snapshot: ActivatedRouteSnapshot): string | null {
    for (const routeSnapshot of snapshot.pathFromRoot) {
      const projectId = routeSnapshot.params['projectId'];
      if (projectId) {
        return projectId;
      }
    }
    return null;
  }
}
